import { FaqRowActions } from 'modules/cms/faq/components/FaqRowActions';
import { EditLink, HeadCell } from '@dfl/mui-admin-layout';
import { IFaq } from 'modules/cms/faq/interfaces';
import { createdATColumn } from 'modules/common/constants/common.columns';
import { FAQ_PERMISSIONS } from 'modules/cms/faq/constants/faq.permissions';

export const faqQuestionColumn: HeadCell<IFaq> = {
  field: 'question',
  headerName: 'faq:fields.question',
  disablePadding: false,
  renderCell: (question: string, data?: IFaq) => (<EditLink entityId={data?._id as string}>{question}</EditLink>),
};

export const faqAnswerColumn: HeadCell<IFaq> = {
  field: 'answer',
  headerName: 'faq:fields.answer',
};

export const faqStatusColumn: HeadCell<IFaq> = {
  field: 'enabled',
  headerName: 'faq:fields.enabled',
};

export const faqSectionColumn: HeadCell<IFaq> = {
  field: 'section',
  headerName: 'faq:fields.section',
  width: 150,
};

export const faqActionsColumn: HeadCell<IFaq> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: FAQ_PERMISSIONS.FAQ_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: FaqRowActions,
};

export const faqColumns: Array<HeadCell<any>> = [
  faqQuestionColumn,
  faqAnswerColumn,
  faqSectionColumn,
  createdATColumn,
  faqActionsColumn
];
